// ImageThumbnailStrip.tsx
import { motion } from 'framer-motion';

interface ImageThumbnailStripProps {
  images: Array<{ url: string; caption: string }>;
  currentIndex: number;
  onSelect: (index: number) => void;
}

export function ImageThumbnailStrip({
  images,
  currentIndex,
  onSelect,
}: ImageThumbnailStripProps) {
  return (
    <div className="w-full overflow-x-auto">
      <motion.div
        className="flex gap-2 p-2 min-w-min"
        initial={false}
        animate={{
          x: Math.max(
            Math.min(0, -(currentIndex * 100) + window.innerWidth / 2 - 50),
            -((images.length - 1) * 100)
          ),
        }}
      >
        {images.map((image, index) => (
          <motion.div
            key={index}
            className={`relative flex-shrink-0 cursor-pointer rounded-md overflow-hidden
              ${index === currentIndex ? 'ring-2 ring-blue-500' : 'opacity-60 hover:opacity-100'}`}
            onClick={() => onSelect(index)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <img
              src={image.url}
              alt={image.caption}
              className="w-16 h-16 object-cover"
            />
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
